var endpointEnabled = process.env.USE_ENDPOINT === "true";
export { endpointEnabled };
